const _ = require('lodash');
export const getToken = state => _.get(state, 'auth.info.accessToken.jwtToken');